import ErrorOutline from '@mui/icons-material/ErrorOutline'
import { useMutation } from '@tanstack/react-query'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'
import useDialog from 'hooks/Shared/useDialog'
import { selectErrorDialog } from 'lib/helpers/errors.helpers'
import { MutationOptions } from 'models/general'
import { IInvoice } from 'models/invoices.models'
import { changeCfdiPaymentStatus } from 'services/Invoices/invoices.services'

const useChangeCFDIPaymentStatus = (
  workspaceId: number,
  options: MutationOptions<void, { invoice: IInvoice; status: string }> = {}
) => {
  const dialog = useDialog()
  const { onBefore, onError, noDialog, ...rest } = options

  const mutation = useMutation<void, any, { invoice: IInvoice; status: string }>(
    ({ invoice, status }) => {
      onBefore && onBefore({ invoice, status })
      return changeCfdiPaymentStatus(workspaceId, invoice, status)
    },
    {
      ...rest,
      onError: async (error, variables, ctx) => {
        if (error.message === 'mutation-cancelled') return
        const op = selectErrorDialog(error)
        if (op?.variant) {
          await dialog[op.variant](op)
          return
        }
        if (!noDialog) {
          const rp = await dialog.dangerAsync({
            title: 'generic.error.title',
            subtitle: 'No se pudo cambiar el estatus del CFDI seleccionado.',
            icon: ErrorOutline as TModalIcon,
            primaryButtonText: 'Reintentar',
            secondaryButtonText: 'Cancelar',
          })

          if (rp) {
            mutation.mutate(variables)
            return
          }
        }

        onError && onError(error, variables, ctx)
      },
    }
  )

  return mutation
}

export default useChangeCFDIPaymentStatus
